import React, { useEffect, useState } from "react";
import UseGeneral from "../../hooks/useGeneral";
import VerificationInput from "react-verification-input";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router";
import "./confpage.css";
import { Axios } from "../../Axios";
import { BASE_URL } from "../../Axios/base_url";
import { ThreeCircles, ThreeDots } from "react-loader-spinner";
import axios from "axios";

const ConePage = () => {
  const { language } = UseGeneral();
  const navigate = useNavigate();
  const location = useLocation();
  const [sendAgainLoading,setSendAdainLoading]=useState(false)
  const [code, setCode] = useState();
  const [loading, setLoading] = useState(false);

  const [current, setCurrent] = useState(66);
  const [timeExp,setTimeExp]=useState(60);
  if (!location.state) {
    navigate(-1);
  }


  let number=location?.state?.phone.slice(-3)+'*******';

  
  const handleSubmit = (e) => {
    e.preventDefault();
    
    const data_send={
      code,
      phone:location?.state?.phone
    }
    
    // return
    setLoading(true);
    Axios({
      url: BASE_URL + "user/check_verf_code",
      method: "POST",
      data:data_send
      // data: { phone: location.state.phone, code },
    })
      .then((res) => {
        
        
        if (res.status == "success") {
          toast.success(res.message);
          navigate("/newpass", {
            state: { phone: location?.state?.phone },
          });
        }
        if(res.status=='faild'){
          toast.error(res.message)
        }
      })
      .catch((e) => {
        
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleSendVerf=()=>{
    setSendAdainLoading(true)
    const data_send={
      phone:location?.state?.phone
    }
    axios.post(BASE_URL+'user/send_verf_code',data_send,{
      headers:{
        lang:language
      }
    })
    .then((res)=>{
      
      if(res.data.status=='faild'){
        toast.error(res.data.message);
      }
      
      if(res.data.status=='success'){
        setTimeExp(60)
        // navigate('/confnumber',{state:{phone:phoneNumber}});
        toast.success(res.data.message)
      }
    }).catch(e=>e)
    .finally(()=>{
      setSendAdainLoading(false)
    })
  }
  useEffect(()=>{
    if(timeExp>0){
      setTimeout(() => {
        setTimeExp(timeExp-1)
      }, 1000);
    }
  },[timeExp])
  useEffect(() => {
    document.title =
      language == "ar" ? "الصيداوي | رمز التحقق  " : "Al-Seedawi | Confirm Code";
  }, []);
  return (
    <div className="conf_page">
      <div className="conf_content">

        <div className="left">
          {language == "ar" ? <h4>رمز التحقق</h4> : <h4>Conformation Code</h4>}
          {language == "ar" ? (
            <p>
              تم إرسال الرمز إلى رقم <span>{number}</span>
            </p>
          ) : (
            <p>
              The code has been sent to a number:{" "}
              <span>{number}</span>
            </p>
          )}
          {language == "ar" ? (
            <p>
              الرقم غير صحيح؟ <span
                onClick={()=>{
                  navigate(-1)
                }}
              >تغيير</span>
            </p>
          ) : (
            <p>
              Number is Incorrect{" "}
              <span onClick={()=>{
                navigate(-1)
              }} style={{ cursor: "pointer" }}>Change</span>
            </p>
          )}
          <h5>{language == "ar" ? "أدخل رمز التحقق" : "Enter Confirm Code"}</h5>
          <div className="inputs">
            <VerificationInput onChange={(e) => setCode(e)} />
          </div>
          {
            sendAgainLoading?
            <ThreeDots color="red"/>
            :
            language == "ar" ? (
              <p style={{cursor:'pointer'}} onClick={()=>{
                if(timeExp!=0){
                  toast.error(language=='ar'?'عند إنتهاء العد':'After Counter Endded')
                  return
                }
                handleSendVerf()
              }} className="resend">إعادة إرسال الرمز <span style={{color:'red'}}>{timeExp}</span></p>
            ) : (
              <p style={{cursor:'pointer'}} onClick={()=>{
                if(timeExp!=0){
                  toast.error(language=='ar'?'عند إنتهاء العد':'After Counter Endded')
                  return
                }
                handleSendVerf()
              }} className="resend">Resend Code After <span style={{color:'red'}}>{timeExp}</span></p>
            )
          }
          {loading ? (
            <div className="loading">
              <ThreeDots color="red"/>
            </div>
          ) : (
            <button onClick={handleSubmit}>
              {language == "ar" ? "التحقق" : "Confirm"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConePage;
